module.exports = __webpack_public_path__ + "img/slika63.2698343d.jpg";